export function createActivityEventId(cryptoApi = globalThis.crypto) {
  if (typeof cryptoApi?.randomUUID === "function") return cryptoApi.randomUUID();
  const bytes = new Uint8Array(16);
  cryptoApi?.getRandomValues?.(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const value = [...bytes].map((byte) => byte.toString(16).padStart(2, "0"));
  return `${value.slice(0, 4).join("")}-${value.slice(4, 6).join("")}-${value.slice(6, 8).join("")}-${value.slice(8, 10).join("")}-${value.slice(10).join("")}`;
}

export async function postOpenedActivity({
  apiUrl,
  getAccessToken,
  action,
  appId,
  toolId = null,
  payload = {},
  eventId = createActivityEventId(),
  fetcher = globalThis.fetch,
}) {
  const token = getAccessToken ? await getAccessToken() : null;
  const response = await fetcher(`${apiUrl}/api/activity/opened`, {
    method: "POST",
    credentials: "include",
    keepalive: true,
    headers: {
      "content-type": "application/json",
      ...(token ? { authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({
      eventId,
      action,
      appId,
      ...(toolId ? { toolId } : {}),
      ...(Object.keys(payload).length ? { payload } : {}),
    }),
  });
  if (!response.ok) {
    throw new Error(`activity_event_failed:${response.status}`);
  }
  return eventId;
}
